export default {"src":"/_next/static/media/main-menu.32920a5e.svg","height":36,"width":36};